import React, { PureComponent } from 'react';
import { DisplayType } from '../../helpers/constants';

export interface CheckBoxProps {
  width: number;
  height: number;
  maxSize?: number;
  padding?: number;
  foregroundColor?: string;
  foregroundColorOpacity?: number;
  displayType?: number;
  align?: string;
}

export default class CheckBox extends PureComponent<CheckBoxProps> {
  render() {
    const lineWidth = 3;
    const style = {
      stroke: this.props.foregroundColor,
      strokeOpacity: this.props.foregroundColorOpacity,
      strokeWidth: lineWidth,
      fill: undefined,
      fillOpacity: undefined
    };

    if (this.props.displayType === DisplayType.FilledOval) {
      style.fill = this.props.foregroundColor;
      style.fillOpacity = this.props.foregroundColorOpacity;
      style.stroke = 'none';
    } else {
      style.fill = 'transparent';
    }

    let adjustedWidth = this.props.width;
    let adjustedHeight = this.props.height;
    let adjustedX = 0;
    let adjustedY = 0;

    if (this.props.padding) {
      adjustedWidth -= this.props.padding * 2;
      adjustedHeight -= this.props.padding * 2;
    }

    if (this.props.maxSize) {
      adjustedWidth = adjustedWidth > this.props.maxSize ? this.props.maxSize : adjustedWidth;
      adjustedHeight = adjustedHeight > this.props.maxSize ? this.props.maxSize : adjustedHeight;
    }

    if (this.props.displayType !== DisplayType.Oval && this.props.displayType !== DisplayType.FilledOval) {
      adjustedWidth = adjustedWidth > adjustedHeight ? adjustedHeight : adjustedWidth;
      adjustedHeight = adjustedHeight > adjustedWidth ? adjustedWidth : adjustedHeight;
    }

    adjustedY = this.props.height / 2 - adjustedHeight / 2;

    const align = this.props.align ? this.props.align.toLowerCase() : 'left';
    if (align === 'center') {
      adjustedX = this.props.width / 2 - adjustedWidth / 2;
    } else if (align === 'right') {
      adjustedX = this.props.width - adjustedWidth;
    }

    switch (this.props.displayType) {
      case DisplayType.Xmark:
        return (
          <svg>
            <line x1={adjustedX} y1={adjustedY} x2={adjustedX + adjustedWidth} y2={adjustedY + adjustedHeight} style={style} />
            <line x1={adjustedX} y1={adjustedY + adjustedHeight} x2={adjustedX + adjustedWidth} y2={adjustedY} style={style} />
          </svg>
        );

      case DisplayType.Checkmark:
        return (
          <svg>
            <line
              x1={adjustedX + lineWidth}
              y1={adjustedY + (adjustedHeight / 7) * 4}
              x2={adjustedX + (adjustedWidth / 7) * 3}
              y2={adjustedY + adjustedHeight}
              style={style}
            />
            <line
              x1={adjustedX + (adjustedWidth / 7) * 3}
              y1={adjustedY + adjustedHeight}
              x2={adjustedX + adjustedWidth - lineWidth}
              y2={adjustedY + adjustedHeight / 6}
              style={style}
            />
          </svg>
        );

      case DisplayType.Oval:
      case DisplayType.Circle:
      default:
        return (
          <svg>
            <ellipse cx="50%" cy="50%" rx={Math.max(adjustedWidth / 2 - lineWidth, 1)} ry={Math.max(adjustedHeight / 2 - lineWidth, 1)} style={style} />
          </svg>
        );
      case DisplayType.FilledOval:
        return (
          <svg>
            <ellipse cx="50%" cy="50%" rx={Math.max(adjustedWidth / 2, 1)} ry={Math.max(adjustedHeight / 2, 1)} style={style} />
          </svg>
        );
    }
  }
}
